import { Vue, Options } from 'vue-class-component';
import {
  IRoomObjectDTO,
  RoomDTO,
} from 'client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';
import { IDefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'AssignRoomObjectGeneralStep',
  props: {
    roomObject: {
      type: Object as PropType<IRoomObjectDTO>,
      required: true,
    },
    plantId: {
      type: Number,
      required: true,
    },
    roomId: {
      type: String,
      required: true,
    },
    roomName: {
      type: String,
      required: true,
    },
    roomType: {
      type: Number,
      required: true,
    },
    defaultSettings: {
      type: Object as PropType<IDefaultDevicesSettingsDTO[]>,
      required: true,
    },
  },
  emits: ['update:defaultSettings', 'next-enabled'],
  watch: {
    nextEnabled: function () {
      this.emitIsNextEnabled();
    },
  },
})
export default class AssignRoomObjectGeneralStep extends Vue {
  defaultSettings!: IDefaultDevicesSettingsDTO[];
  roomObject!: IRoomObjectDTO;
  plantId!: number;
  roomId!: string;
  roomName!: string;
  roomType!: number;
  SlotRuleServiceType = SlotRuleServiceType;

  nextEnabled = true;

  emitIsNextEnabled() {
    this.$emit('next-enabled', this.nextEnabled);
  }
}
